export default function (number: any) {
  return number.replace(/[()\-_.\s]/g, '')
}
